export const workflowTriggerViews = ($http: HttpApi) => ({
  create: (workflowTriggerId: string, viewId: string) => $http.$post('/builder/workflow_trigger_views', { body: { workflow_trigger_id: workflowTriggerId, view_id: viewId } }),
  delete: (workflowTriggerId: string, viewId: string) => $http.$delete('/builder/workflow_trigger_views', { body: { workflow_trigger_id: workflowTriggerId, view_id: viewId } }),
});
